import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import { Button, Row, Col, Modal, Form, Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Create from './Create';
import { AppSettings } from '../../../settings';
import CallApi from 'components/common/custom-components/CallApi';
import PageInfo from 'components/common/custom-components/PageInfo';
import React from 'react';

const Networks = () => {
  const [networks, setNetworks] = useState([]);
  const [show, setShow] = useState(false);
  const [networkId, setNetworkId] = useState('');
  const [apiCallInProcess, setApiCallInProcess] = useState(false);

  const columns = [
    {
      accessor: 'id',
      Header: 'Actions',
      Cell: ({ cell }) => {
        return (
          <>
            <IconButton
              icon="edit"
              size="sm"
              className="me-2"
              onClick={() => updateNetwork(cell.row.values.id)}
            />
            <IconButton
              variant="danger"
              icon="trash-alt"
              size="sm"
              onClick={() => deleteNetwork(cell.row.values.id)}
            />
          </>
        );
      }
    },
    {
      Header: 'Icon',
      Cell: ({ cell }) => {
        return (
          <FontAwesomeIcon
            icon={[cell.row.original.icon_prefix, cell.row.original.icon_name]}
            size="lg"
          />
        );
      }
    },
    {
      accessor: 'name',
      Header: 'Name'
    },
    {
      accessor: 'description',
      Header: 'Description'
    }
  ];

  function deleteNetwork(id) {
    if (confirm("Attention! Are you sure you'd like to delete?")) {
      CallApi.delete(`/networks/${id}`).then(json => {
        if (json.status == 200) loadListing();
      });
    }
  }

  function updateNetwork(id) {
    setNetworkId(id);
    setShow(true);
  }

  function loadListing() {
    setApiCallInProcess(true);
    CallApi.get(`/networks`).then(data => {
      setApiCallInProcess(false);
      if (data.status == 200) {
        setNetworks(data.data);
      }
    });
  }

  useEffect(() => {
    loadListing();
  }, []);

  const handleShow = () => setShow(true);
  const handleHide = () => {
    setNetworkId('');
    setShow(false);
  };

  return (
    <>
      <PageInfo slug="networks" />
      <Card>
        <Card.Body>
          <AdvanceTableWrapper
            columns={columns}
            data={networks}
            sortable
            pagination
          >
            <Row className="align-items-end g-2 row mb-3">
              <Col className="col-auto" xs="auto" sm={6} lg={4}>
                <AdvanceTableSearchBox table />
              </Col>
              <Col className="col">
                <IconButton
                  icon="plus"
                  size="sm"
                  className="float-end"
                  onClick={handleShow}
                >
                  Add New
                </IconButton>
              </Col>
            </Row>
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                bordered: true,
                striped: true,
                className: 'fs--1 mb-0 overflow-hidden'
              }}
              apiCallInProcess={apiCallInProcess}
            />
            <div className="mt-3">
              <AdvanceTableFooter
                rowCount={networks.length}
                table
                rowInfo
                navButtons
                rowsPerPageSelection
              />
            </div>
          </AdvanceTableWrapper>
        </Card.Body>
      </Card>

      <Modal show={show} onHide={handleHide}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add a new Network
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Create
            loadListing={loadListing}
            setShow={setShow}
            networkId={networkId}
            setNetworkId={setNetworkId}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Networks;
